/**
 * Format the CPF value
 * @param cleanValue - The value to format
 * @returns The formatted value
 */
export const formatCpf = (cleanValue: string): string => {
  const part1 = cleanValue.substring(0, 3)
  const part2 = cleanValue.substring(3, 6)
  const part3 = cleanValue.substring(6, 9)
  const part4 = cleanValue.substring(9, 11)

  return `${part1}.${part2 || '___'}.${part3 || '___'}-${part4 || '__'}`
}

/**
 * Format the CNPJ value
 * @param cleanValue - The value to format
 * @returns The formatted value
 */
export const formatCnpj = (cleanValue: string): string => {
  const part1 = cleanValue.substring(0, 2)
  const part2 = cleanValue.substring(2, 5)
  const part3 = cleanValue.substring(5, 8)
  const part4 = cleanValue.substring(8, 12)
  const part5 = cleanValue.substring(12, 14)

  return `${part1}.${part2 || '___'}.${part3 || '___'}/${part4 || '____'}-${
    part5 || '__'
  }`
}

/**
 * Remove all non-numeric characters from the value
 * @param value - The value to sanitize
 * @returns The sanitized value
 */
export const sanitizeValue = (value: string | number): string =>
  String(value).replace(/\D/g, '')
